import { render, staticRenderFns } from "./CourseDetailStep.vue?vue&type=template&id=b411ccf8&scoped=true"
import script from "./CourseDetailStep.vue?vue&type=script&lang=js"
export * from "./CourseDetailStep.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailStep.vue?vue&type=style&index=0&id=b411ccf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b411ccf8",
  null
  
)

export default component.exports